export interface ThaiAddressOption {
  subDistrict: string;
  district: string;
  province: string;
}

// Format: [subDistrict, district, province][]
// Data sourced from Thailand Post database. Extend as needed.
type Entry = [string, string, string];

const RAW: Record<string, Entry[]> = {
  // =================== กรุงเทพมหานคร ===================
  "10100": [
    ["ตลาดน้อย", "สัมพันธวงศ์", "กรุงเทพมหานคร"],
    ["สัมพันธวงศ์", "สัมพันธวงศ์", "กรุงเทพมหานคร"],
    ["จักรวรรดิ", "สัมพันธวงศ์", "กรุงเทพมหานคร"],
  ],
  "10110": [
    ["คลองมหานาค", "ป้อมปราบศัตรูพ่าย", "กรุงเทพมหานคร"],
    ["บ้านบาตร", "ป้อมปราบศัตรูพ่าย", "กรุงเทพมหานคร"],
    ["วัดเทพศิรินทร์", "ป้อมปราบศัตรูพ่าย", "กรุงเทพมหานคร"],
    ["ป้อมปราบ", "ป้อมปราบศัตรูพ่าย", "กรุงเทพมหานคร"],
  ],
  "10120": [
    ["ช่องนนทรี", "ยานนาวา", "กรุงเทพมหานคร"],
    ["บางโพงพาง", "ยานนาวา", "กรุงเทพมหานคร"],
    ["ทุ่งมหาเมฆ", "สาทร", "กรุงเทพมหานคร"],
    ["ทุ่งวัดดอน", "สาทร", "กรุงเทพมหานคร"],
    ["ยานนาวา", "สาทร", "กรุงเทพมหานคร"],
  ],
  "10140": [
    ["บางคอแหลม", "บางคอแหลม", "กรุงเทพมหานคร"],
    ["บางโคล่", "บางคอแหลม", "กรุงเทพมหานคร"],
    ["วัดพระยาไกร", "บางคอแหลม", "กรุงเทพมหานคร"],
  ],
  "10150": [
    ["ท่าข้าม", "บางขุนเทียน", "กรุงเทพมหานคร"],
    ["บางขุนเทียน", "บางขุนเทียน", "กรุงเทพมหานคร"],
    ["จอมทอง", "จอมทอง", "กรุงเทพมหานคร"],
    ["บางมด", "จอมทอง", "กรุงเทพมหานคร"],
    ["บางขุนเทียน", "จอมทอง", "กรุงเทพมหานคร"],
  ],
  "10160": [
    ["ปากคลองภาษีเจริญ", "ภาษีเจริญ", "กรุงเทพมหานคร"],
    ["คูหาสวรรค์", "ภาษีเจริญ", "กรุงเทพมหานคร"],
    ["บางหว้า", "ภาษีเจริญ", "กรุงเทพมหานคร"],
    ["บางด้วน", "ภาษีเจริญ", "กรุงเทพมหานคร"],
    ["บางแวก", "ภาษีเจริญ", "กรุงเทพมหานคร"],
    ["คลองขวาง", "ภาษีเจริญ", "กรุงเทพมหานคร"],
    ["หนองแขม", "หนองแขม", "กรุงเทพมหานคร"],
    ["หนองค้างพลู", "หนองแขม", "กรุงเทพมหานคร"],
  ],
  "10170": [
    ["ตลิ่งชัน", "ตลิ่งชัน", "กรุงเทพมหานคร"],
    ["บางพรม", "ตลิ่งชัน", "กรุงเทพมหานคร"],
    ["บางระมาด", "ตลิ่งชัน", "กรุงเทพมหานคร"],
    ["ฉิมพลี", "ตลิ่งชัน", "กรุงเทพมหานคร"],
    ["บางเชือกหนัง", "ตลิ่งชัน", "กรุงเทพมหานคร"],
    ["คลองชักพระ", "ตลิ่งชัน", "กรุงเทพมหานคร"],
  ],
  "10200": [
    ["พระบรมมหาราชวัง", "พระนคร", "กรุงเทพมหานคร"],
    ["วังบูรพาภิรมย์", "พระนคร", "กรุงเทพมหานคร"],
    ["วัดราชบพิธ", "พระนคร", "กรุงเทพมหานคร"],
    ["สำราญราษฎร์", "พระนคร", "กรุงเทพมหานคร"],
    ["บ้านพานถม", "พระนคร", "กรุงเทพมหานคร"],
    ["บวรนิเวศ", "พระนคร", "กรุงเทพมหานคร"],
    ["ตลาดยอด", "พระนคร", "กรุงเทพมหานคร"],
    ["ชนะสงคราม", "พระนคร", "กรุงเทพมหานคร"],
    ["อิสรภาพ", "พระนคร", "กรุงเทพมหานคร"],
  ],
  "10210": [
    ["สีกัน", "ดอนเมือง", "กรุงเทพมหานคร"],
    ["ดอนเมือง", "ดอนเมือง", "กรุงเทพมหานคร"],
    ["แขวงหลักสี่", "หลักสี่", "กรุงเทพมหานคร"],
    ["ตลาดบางเขน", "หลักสี่", "กรุงเทพมหานคร"],
  ],
  "10220": [
    ["ท่าแร้ง", "บางเขน", "กรุงเทพมหานคร"],
    ["อนุสาวรีย์", "บางเขน", "กรุงเทพมหานคร"],
  ],
  "10230": [
    ["ลาดพร้าว", "ลาดพร้าว", "กรุงเทพมหานคร"],
    ["จรเข้บัว", "ลาดพร้าว", "กรุงเทพมหานคร"],
  ],
  "10240": [
    ["คลองจั่น", "บางกะปิ", "กรุงเทพมหานคร"],
    ["หัวหมาก", "บางกะปิ", "กรุงเทพมหานคร"],
  ],
  "10250": [
    ["คลองกุ่ม", "บึงกุ่ม", "กรุงเทพมหานคร"],
    ["นวมินทร์", "บึงกุ่ม", "กรุงเทพมหานคร"],
    ["นวลจันทร์", "บึงกุ่ม", "กรุงเทพมหานคร"],
  ],
  "10260": [
    ["พระโขนง", "พระโขนง", "กรุงเทพมหานคร"],
    ["บางจาก", "พระโขนง", "กรุงเทพมหานคร"],
    ["ประเวศ", "ประเวศ", "กรุงเทพมหานคร"],
    ["หนองบอน", "ประเวศ", "กรุงเทพมหานคร"],
    ["ดอกไม้", "ประเวศ", "กรุงเทพมหานคร"],
  ],
  "10270": [
    ["บางนา", "บางนา", "กรุงเทพมหานคร"],
  ],
  "10280": [
    ["สมุทรปราการ", "เมืองสมุทรปราการ", "สมุทรปราการ"],
    ["ปากน้ำ", "เมืองสมุทรปราการ", "สมุทรปราการ"],
    ["บางเมือง", "เมืองสมุทรปราการ", "สมุทรปราการ"],
    ["ท้ายบ้าน", "เมืองสมุทรปราการ", "สมุทรปราการ"],
  ],
  "10290": [
    ["บางปู", "เมืองสมุทรปราการ", "สมุทรปราการ"],
    ["บางปูใหม่", "เมืองสมุทรปราการ", "สมุทรปราการ"],
  ],
  "10300": [
    ["ดุสิต", "ดุสิต", "กรุงเทพมหานคร"],
    ["สวนจิตรลดา", "ดุสิต", "กรุงเทพมหานคร"],
    ["สี่แยกมหานาค", "ดุสิต", "กรุงเทพมหานคร"],
    ["วชิรพยาบาล", "ดุสิต", "กรุงเทพมหานคร"],
    ["ถนนนครไชยศรี", "ดุสิต", "กรุงเทพมหานคร"],
  ],
  "10310": [
    ["วังทองหลาง", "วังทองหลาง", "กรุงเทพมหานคร"],
    ["คลองเจ้าคุณสิงห์", "วังทองหลาง", "กรุงเทพมหานคร"],
    ["สะพานสอง", "วังทองหลาง", "กรุงเทพมหานคร"],
    ["พลับพลา", "วังทองหลาง", "กรุงเทพมหานคร"],
  ],
  "10330": [
    ["บางซื่อ", "บางซื่อ", "กรุงเทพมหานคร"],
    ["วงศ์สว่าง", "บางซื่อ", "กรุงเทพมหานคร"],
  ],
  "10400": [
    ["สามเสนใน", "พญาไท", "กรุงเทพมหานคร"],
    ["พญาไท", "พญาไท", "กรุงเทพมหานคร"],
    ["สามเสนนอก", "ห้วยขวาง", "กรุงเทพมหานคร"],
    ["ห้วยขวาง", "ห้วยขวาง", "กรุงเทพมหานคร"],
    ["บางกะปิ", "ห้วยขวาง", "กรุงเทพมหานคร"],
  ],
  "10500": [
    ["มหาพฤฒาราม", "บางรัก", "กรุงเทพมหานคร"],
    ["สีลม", "บางรัก", "กรุงเทพมหานคร"],
    ["สุริยวงศ์", "บางรัก", "กรุงเทพมหานคร"],
    ["บางรัก", "บางรัก", "กรุงเทพมหานคร"],
    ["บางรักน้อย", "บางรัก", "กรุงเทพมหานคร"],
  ],
  "10510": [
    ["มีนบุรี", "มีนบุรี", "กรุงเทพมหานคร"],
    ["แสนแสบ", "มีนบุรี", "กรุงเทพมหานคร"],
  ],
  "10520": [
    ["ลาดกระบัง", "ลาดกระบัง", "กรุงเทพมหานคร"],
    ["คลองสาม", "ลาดกระบัง", "กรุงเทพมหานคร"],
    ["คลองสี่", "ลาดกระบัง", "กรุงเทพมหานคร"],
  ],
  "10530": [
    ["กระทุ่มราย", "หนองจอก", "กรุงเทพมหานคร"],
    ["หนองจอก", "หนองจอก", "กรุงเทพมหานคร"],
    ["คูฝอย", "หนองจอก", "กรุงเทพมหานคร"],
  ],
  "10540": [
    ["คลองสาน", "คลองสาน", "กรุงเทพมหานคร"],
    ["สมเด็จเจ้าพระยา", "คลองสาน", "กรุงเทพมหานคร"],
    ["บางลำภูล่าง", "คลองสาน", "กรุงเทพมหานคร"],
    ["คลองต้นไทร", "คลองสาน", "กรุงเทพมหานคร"],
    ["บางพลีใหญ่", "บางพลี", "สมุทรปราการ"],
    ["บางแก้ว", "บางพลี", "สมุทรปราการ"],
    ["บางพลีน้อย", "บางพลี", "สมุทรปราการ"],
  ],
  "10600": [
    ["บางกอกน้อย", "บางกอกน้อย", "กรุงเทพมหานคร"],
    ["บ้านช่างหล่อ", "บางกอกน้อย", "กรุงเทพมหานคร"],
    ["บางขุนนนท์", "บางกอกน้อย", "กรุงเทพมหานคร"],
    ["บางขุนศรี", "บางกอกน้อย", "กรุงเทพมหานคร"],
  ],
  "10700": [
    ["ศิริราช", "บางกอกน้อย", "กรุงเทพมหานคร"],
    ["อรุณอมรินทร์", "บางกอกน้อย", "กรุงเทพมหานคร"],
    ["วัดอรุณ", "บางกอกใหญ่", "กรุงเทพมหานคร"],
    ["วัดท่าพระ", "บางกอกใหญ่", "กรุงเทพมหานคร"],
  ],
  "10800": [
    ["บางซื่อ", "บางซื่อ", "กรุงเทพมหานคร"],
    ["จตุจักร", "จตุจักร", "กรุงเทพมหานคร"],
    ["จอมพล", "จตุจักร", "กรุงเทพมหานคร"],
    ["จันทรเกษม", "จตุจักร", "กรุงเทพมหานคร"],
    ["เสนานิคม", "จตุจักร", "กรุงเทพมหานคร"],
    ["ลาดยาว", "จตุจักร", "กรุงเทพมหานคร"],
  ],
  "10900": [
    ["บางเขน", "บางเขน", "กรุงเทพมหานคร"],
    ["จอแส", "บางเขน", "กรุงเทพมหานคร"],
    ["ออเงิน", "สายไหม", "กรุงเทพมหานคร"],
    ["สายไหม", "สายไหม", "กรุงเทพมหานคร"],
  ],

  // =================== นนทบุรี ===================
  "11000": [
    ["สวนใหญ่", "เมืองนนทบุรี", "นนทบุรี"],
    ["ตลาดขวัญ", "เมืองนนทบุรี", "นนทบุรี"],
    ["บางเขน", "เมืองนนทบุรี", "นนทบุรี"],
    ["บางกระสอ", "เมืองนนทบุรี", "นนทบุรี"],
    ["ท่าทราย", "เมืองนนทบุรี", "นนทบุรี"],
  ],
  "11110": [
    ["บางใหญ่", "บางใหญ่", "นนทบุรี"],
    ["บ้านใหม่", "บางใหญ่", "นนทบุรี"],
    ["บางแม่นาง", "บางใหญ่", "นนทบุรี"],
  ],
  "11120": [
    ["บางบัวทอง", "บางบัวทอง", "นนทบุรี"],
    ["โสนลอย", "บางบัวทอง", "นนทบุรี"],
    ["บางรักพัฒนา", "บางบัวทอง", "นนทบุรี"],
  ],
  "11130": [
    ["บางกรวย", "บางกรวย", "นนทบุรี"],
    ["วัดชลอ", "บางกรวย", "นนทบุรี"],
  ],
  "11140": [
    ["ปากเกร็ด", "ปากเกร็ด", "นนทบุรี"],
    ["บางตลาด", "ปากเกร็ด", "นนทบุรี"],
  ],

  // =================== ปทุมธานี ===================
  "12000": [
    ["บางปรอก", "เมืองปทุมธานี", "ปทุมธานี"],
    ["บ้านใหม่", "เมืองปทุมธานี", "ปทุมธานี"],
    ["บางขะแยง", "เมืองปทุมธานี", "ปทุมธานี"],
  ],
  "12110": [
    ["คลองหนึ่ง", "คลองหลวง", "ปทุมธานี"],
    ["คลองสอง", "คลองหลวง", "ปทุมธานี"],
    ["คลองสาม", "คลองหลวง", "ปทุมธานี"],
  ],
  "12120": [
    ["ธัญบุรี", "ธัญบุรี", "ปทุมธานี"],
    ["รังสิต", "ธัญบุรี", "ปทุมธานี"],
  ],
  "12130": [
    ["ลาดหลุมแก้ว", "ลาดหลุมแก้ว", "ปทุมธานี"],
    ["ระแหง", "ลาดหลุมแก้ว", "ปทุมธานี"],
  ],
  "12150": [
    ["สามโคก", "สามโคก", "ปทุมธานี"],
    ["กระแชง", "สามโคก", "ปทุมธานี"],
  ],
  "12160": [
    ["หนองเสือ", "หนองเสือ", "ปทุมธานี"],
    ["บึงบา", "หนองเสือ", "ปทุมธานี"],
  ],

  // =================== พระนครศรีอยุธยา ===================
  "13000": [
    ["ประตูชัย", "พระนครศรีอยุธยา", "พระนครศรีอยุธยา"],
    ["กะมัง", "พระนครศรีอยุธยา", "พระนครศรีอยุธยา"],
    ["หอรัตนไชย", "พระนครศรีอยุธยา", "พระนครศรีอยุธยา"],
    ["หัวรอ", "พระนครศรีอยุธยา", "พระนครศรีอยุธยา"],
    ["ท่าวาสุกรี", "พระนครศรีอยุธยา", "พระนครศรีอยุธยา"],
    ["ไผ่ลิง", "พระนครศรีอยุธยา", "พระนครศรีอยุธยา"],
    ["ปากกราน", "พระนครศรีอยุธยา", "พระนครศรีอยุธยา"],
    ["ภูเขาทอง", "พระนครศรีอยุธยา", "พระนครศรีอยุธยา"],
    ["สำเภาล่ม", "พระนครศรีอยุธยา", "พระนครศรีอยุธยา"],
    ["สวนพริก", "พระนครศรีอยุธยา", "พระนครศรีอยุธยา"],
    ["คลองสระบัว", "พระนครศรีอยุธยา", "พระนครศรีอยุธยา"],
    ["เวียง", "พระนครศรีอยุธยา", "พระนครศรีอยุธยา"],
    ["ชั้น", "พระนครศรีอยุธยา", "พระนครศรีอยุธยา"],
    ["บ้านใหม่", "พระนครศรีอยุธยา", "พระนครศรีอยุธยา"],
    ["บ้านเกาะ", "พระนครศรีอยุธยา", "พระนครศรีอยุธยา"],
  ],

  // =================== อ่างทอง ===================
  "14000": [
    ["ตลาดหลวง", "เมืองอ่างทอง", "อ่างทอง"],
    ["บ้านแห", "เมืองอ่างทอง", "อ่างทอง"],
    ["ตลาดกรวด", "เมืองอ่างทอง", "อ่างทอง"],
    ["มหาดไทย", "เมืองอ่างทอง", "อ่างทอง"],
  ],

  // =================== ลพบุรี ===================
  "15000": [
    ["ทะเลชุบศร", "เมืองลพบุรี", "ลพบุรี"],
    ["ท่าหิน", "เมืองลพบุรี", "ลพบุรี"],
    ["กกโก", "เมืองลพบุรี", "ลพบุรี"],
    ["โก่งธนู", "เมืองลพบุรี", "ลพบุรี"],
  ],

  // =================== สิงห์บุรี ===================
  "16000": [
    ["บางพุทรา", "เมืองสิงห์บุรี", "สิงห์บุรี"],
    ["บางมัญ", "เมืองสิงห์บุรี", "สิงห์บุรี"],
    ["โพกรวม", "เมืองสิงห์บุรี", "สิงห์บุรี"],
    ["ม่วงหมู่", "เมืองสิงห์บุรี", "สิงห์บุรี"],
  ],

  // =================== ชัยนาท ===================
  "17000": [
    ["ในเมือง", "เมืองชัยนาท", "ชัยนาท"],
    ["บ้านกล้วย", "เมืองชัยนาท", "ชัยนาท"],
    ["ท่าชัย", "เมืองชัยนาท", "ชัยนาท"],
    ["ชัยนาท", "เมืองชัยนาท", "ชัยนาท"],
  ],

  // =================== สระบุรี ===================
  "18000": [
    ["ปากเพรียว", "เมืองสระบุรี", "สระบุรี"],
    ["ดาวเรือง", "เมืองสระบุรี", "สระบุรี"],
    ["นาโฉง", "เมืองสระบุรี", "สระบุรี"],
    ["โคกสว่าง", "เมืองสระบุรี", "สระบุรี"],
  ],

  // =================== นครนายก ===================
  "26000": [
    ["นครนายก", "เมืองนครนายก", "นครนายก"],
    ["ท่าช้าง", "เมืองนครนายก", "นครนายก"],
    ["บ้านใหญ่", "เมืองนครนายก", "นครนายก"],
  ],

  // =================== ฉะเชิงเทรา ===================
  "24000": [
    ["หน้าเมือง", "เมืองฉะเชิงเทรา", "ฉะเชิงเทรา"],
    ["ท่าไข่", "เมืองฉะเชิงเทรา", "ฉะเชิงเทรา"],
    ["บ้านใหม่", "เมืองฉะเชิงเทรา", "ฉะเชิงเทรา"],
    ["คลองนา", "เมืองฉะเชิงเทรา", "ฉะเชิงเทรา"],
  ],

  // =================== ปราจีนบุรี ===================
  "25000": [
    ["หน้าเมือง", "เมืองปราจีนบุรี", "ปราจีนบุรี"],
    ["รอบเมือง", "เมืองปราจีนบุรี", "ปราจีนบุรี"],
    ["วัดโบสถ์", "เมืองปราจีนบุรี", "ปราจีนบุรี"],
  ],

  // =================== สระแก้ว ===================
  "27000": [
    ["สระแก้ว", "เมืองสระแก้ว", "สระแก้ว"],
    ["บ้านแก้ง", "เมืองสระแก้ว", "สระแก้ว"],
    ["ศาลาลำดวน", "เมืองสระแก้ว", "สระแก้ว"],
  ],

  // =================== ชลบุรี ===================
  "20000": [
    ["บางปลาสร้อย", "เมืองชลบุรี", "ชลบุรี"],
    ["มะขามหย่ง", "เมืองชลบุรี", "ชลบุรี"],
    ["บ้านโขด", "เมืองชลบุรี", "ชลบุรี"],
    ["แสนสุข", "เมืองชลบุรี", "ชลบุรี"],
    ["บ้านสวน", "เมืองชลบุรี", "ชลบุรี"],
  ],
  "20110": [
    ["นาเกลือ", "บางละมุง", "ชลบุรี"],
    ["บางละมุง", "บางละมุง", "ชลบุรี"],
    ["หนองปรือ", "บางละมุง", "ชลบุรี"],
    ["หนองปลาไหล", "บางละมุง", "ชลบุรี"],
  ],
  "20130": [
    ["แหลมฉบัง", "ศรีราชา", "ชลบุรี"],
    ["ทุ่งสุขลา", "ศรีราชา", "ชลบุรี"],
    ["บางพระ", "ศรีราชา", "ชลบุรี"],
  ],
  "20150": [
    ["พัทยา", "บางละมุง", "ชลบุรี"],
    ["หนองปรือ", "บางละมุง", "ชลบุรี"],
  ],

  // =================== ระยอง ===================
  "21000": [
    ["ท่าประดู่", "เมืองระยอง", "ระยอง"],
    ["เชิงเนิน", "เมืองระยอง", "ระยอง"],
    ["ตะพง", "เมืองระยอง", "ระยอง"],
    ["ปากน้ำ", "เมืองระยอง", "ระยอง"],
    ["เพ", "เมืองระยอง", "ระยอง"],
  ],

  // =================== จันทบุรี ===================
  "22000": [
    ["ตลาด", "เมืองจันทบุรี", "จันทบุรี"],
    ["วัดใหม่", "เมืองจันทบุรี", "จันทบุรี"],
    ["คลองนารายณ์", "เมืองจันทบุรี", "จันทบุรี"],
    ["เกาะขวาง", "เมืองจันทบุรี", "จันทบุรี"],
    ["คมบาง", "เมืองจันทบุรี", "จันทบุรี"],
  ],

  // =================== ตราด ===================
  "23000": [
    ["บางพระ", "เมืองตราด", "ตราด"],
    ["หนองเสม็ด", "เมืองตราด", "ตราด"],
    ["หนองโสน", "เมืองตราด", "ตราด"],
    ["ห้วยแร้ง", "เมืองตราด", "ตราด"],
    ["วังกระแจะ", "เมืองตราด", "ตราด"],
  ],

  // =================== สมุทรปราการ ===================
  "10550": [
    ["บางบ่อ", "บางบ่อ", "สมุทรปราการ"],
    ["บ้านระกาศ", "บางบ่อ", "สมุทรปราการ"],
  ],

  // =================== นครราชสีมา ===================
  "30000": [
    ["ในเมือง", "เมืองนครราชสีมา", "นครราชสีมา"],
    ["โพธิ์กลาง", "เมืองนครราชสีมา", "นครราชสีมา"],
    ["หัวทะเล", "เมืองนครราชสีมา", "นครราชสีมา"],
    ["บ้านเกาะ", "เมืองนครราชสีมา", "นครราชสีมา"],
    ["บ้านใหม่", "เมืองนครราชสีมา", "นครราชสีมา"],
    ["หมื่นไวย", "เมืองนครราชสีมา", "นครราชสีมา"],
    ["พลกรัง", "เมืองนครราชสีมา", "นครราชสีมา"],
    ["หนองจะบก", "เมืองนครราชสีมา", "นครราชสีมา"],
    ["โคกสูง", "เมืองนครราชสีมา", "นครราชสีมา"],
    ["มะเริง", "เมืองนครราชสีมา", "นครราชสีมา"],
    ["หนองระเวียง", "เมืองนครราชสีมา", "นครราชสีมา"],
    ["ปรุใหญ่", "เมืองนครราชสีมา", "นครราชสีมา"],
  ],

  // =================== บุรีรัมย์ ===================
  "31000": [
    ["ในเมือง", "เมืองบุรีรัมย์", "บุรีรัมย์"],
    ["อิสาณ", "เมืองบุรีรัมย์", "บุรีรัมย์"],
    ["เสม็ด", "เมืองบุรีรัมย์", "บุรีรัมย์"],
    ["บ้านบัว", "เมืองบุรีรัมย์", "บุรีรัมย์"],
  ],

  // =================== สุรินทร์ ===================
  "32000": [
    ["ในเมือง", "เมืองสุรินทร์", "สุรินทร์"],
    ["ตั้งใจ", "เมืองสุรินทร์", "สุรินทร์"],
    ["เพี้ยราม", "เมืองสุรินทร์", "สุรินทร์"],
    ["นาดี", "เมืองสุรินทร์", "สุรินทร์"],
  ],

  // =================== ศรีสะเกษ ===================
  "33000": [
    ["เมืองเหนือ", "เมืองศรีสะเกษ", "ศรีสะเกษ"],
    ["เมืองใต้", "เมืองศรีสะเกษ", "ศรีสะเกษ"],
    ["คูซอด", "เมืองศรีสะเกษ", "ศรีสะเกษ"],
    ["ซำ", "เมืองศรีสะเกษ", "ศรีสะเกษ"],
  ],

  // =================== อุบลราชธานี ===================
  "34000": [
    ["ในเมือง", "เมืองอุบลราชธานี", "อุบลราชธานี"],
    ["จระเข้ใหญ่", "เมืองอุบลราชธานี", "อุบลราชธานี"],
    ["ไร่น้อย", "เมืองอุบลราชธานี", "อุบลราชธานี"],
    ["กระโสบ", "เมืองอุบลราชธานี", "อุบลราชธานี"],
    ["ขามใหญ่", "เมืองอุบลราชธานี", "อุบลราชธานี"],
  ],

  // =================== ยโสธร ===================
  "35000": [
    ["ในเมือง", "เมืองยโสธร", "ยโสธร"],
    ["สมเด็จ", "เมืองยโสธร", "ยโสธร"],
    ["น้ำคำใหญ่", "เมืองยโสธร", "ยโสธร"],
  ],

  // =================== ชัยภูมิ ===================
  "36000": [
    ["ในเมือง", "เมืองชัยภูมิ", "ชัยภูมิ"],
    ["รอบเมือง", "เมืองชัยภูมิ", "ชัยภูมิ"],
    ["โพนทอง", "เมืองชัยภูมิ", "ชัยภูมิ"],
    ["นาฝาย", "เมืองชัยภูมิ", "ชัยภูมิ"],
  ],

  // =================== อำนาจเจริญ ===================
  "37000": [
    ["บุ่ง", "เมืองอำนาจเจริญ", "อำนาจเจริญ"],
    ["ไก่คำ", "เมืองอำนาจเจริญ", "อำนาจเจริญ"],
    ["นาหมอม้า", "เมืองอำนาจเจริญ", "อำนาจเจริญ"],
  ],

  // =================== บึงกาฬ ===================
  "38000": [
    ["บึงกาฬ", "เมืองบึงกาฬ", "บึงกาฬ"],
    ["หอคำ", "เมืองบึงกาฬ", "บึงกาฬ"],
    ["หนองเลิง", "เมืองบึงกาฬ", "บึงกาฬ"],
  ],

  // =================== หนองบัวลำภู ===================
  "39000": [
    ["หนองบัว", "เมืองหนองบัวลำภู", "หนองบัวลำภู"],
    ["หนองภัยศูนย์", "เมืองหนองบัวลำภู", "หนองบัวลำภู"],
    ["นามะเฟือง", "เมืองหนองบัวลำภู", "หนองบัวลำภู"],
  ],

  // =================== ขอนแก่น ===================
  "40000": [
    ["ในเมือง", "เมืองขอนแก่น", "ขอนแก่น"],
    ["สาวะถี", "เมืองขอนแก่น", "ขอนแก่น"],
    ["บ้านทุ่ม", "เมืองขอนแก่น", "ขอนแก่น"],
    ["เมืองเก่า", "เมืองขอนแก่น", "ขอนแก่น"],
    ["พระลับ", "เมืองขอนแก่น", "ขอนแก่น"],
    ["สงเปลือย", "เมืองขอนแก่น", "ขอนแก่น"],
    ["โนนทอง", "เมืองขอนแก่น", "ขอนแก่น"],
    ["บ้านเป็ด", "เมืองขอนแก่น", "ขอนแก่น"],
    ["หนองตูม", "เมืองขอนแก่น", "ขอนแก่น"],
    ["บึงเนียม", "เมืองขอนแก่น", "ขอนแก่น"],
  ],

  // =================== อุดรธานี ===================
  "41000": [
    ["หมากแข้ง", "เมืองอุดรธานี", "อุดรธานี"],
    ["นิคมสงเคราะห์", "เมืองอุดรธานี", "อุดรธานี"],
    ["บ้านเลื่อม", "เมืองอุดรธานี", "อุดรธานี"],
    ["หนองบัว", "เมืองอุดรธานี", "อุดรธานี"],
    ["บ้านจั่น", "เมืองอุดรธานี", "อุดรธานี"],
    ["หมู่ที่ 5", "เมืองอุดรธานี", "อุดรธานี"],
    ["กุดสระ", "เมืองอุดรธานี", "อุดรธานี"],
  ],

  // =================== เลย ===================
  "42000": [
    ["กุดป่อง", "เมืองเลย", "เลย"],
    ["เมือง", "เมืองเลย", "เลย"],
    ["นาอาน", "เมืองเลย", "เลย"],
    ["นาโป่ง", "เมืองเลย", "เลย"],
  ],

  // =================== หนองคาย ===================
  "43000": [
    ["ในเมือง", "เมืองหนองคาย", "หนองคาย"],
    ["มีชัย", "เมืองหนองคาย", "หนองคาย"],
    ["โพธิ์ชัย", "เมืองหนองคาย", "หนองคาย"],
    ["หาดคำ", "เมืองหนองคาย", "หนองคาย"],
    ["กวนวัน", "เมืองหนองคาย", "หนองคาย"],
  ],

  // =================== มหาสารคาม ===================
  "44000": [
    ["ตลาด", "เมืองมหาสารคาม", "มหาสารคาม"],
    ["เขวา", "เมืองมหาสารคาม", "มหาสารคาม"],
    ["ท่าขอนยาง", "เมืองมหาสารคาม", "มหาสารคาม"],
    ["แวงน่าง", "เมืองมหาสารคาม", "มหาสารคาม"],
  ],

  // =================== ร้อยเอ็ด ===================
  "45000": [
    ["ในเมือง", "เมืองร้อยเอ็ด", "ร้อยเอ็ด"],
    ["รอบเมือง", "เมืองร้อยเอ็ด", "ร้อยเอ็ด"],
    ["โนนรัง", "เมืองร้อยเอ็ด", "ร้อยเอ็ด"],
    ["หนองแก้ว", "เมืองร้อยเอ็ด", "ร้อยเอ็ด"],
  ],

  // =================== กาฬสินธุ์ ===================
  "46000": [
    ["กาฬสินธุ์", "เมืองกาฬสินธุ์", "กาฬสินธุ์"],
    ["เหนือ", "เมืองกาฬสินธุ์", "กาฬสินธุ์"],
    ["ลำปาว", "เมืองกาฬสินธุ์", "กาฬสินธุ์"],
  ],

  // =================== สกลนคร ===================
  "47000": [
    ["ธาตุเชิงชุม", "เมืองสกลนคร", "สกลนคร"],
    ["ขมิ้น", "เมืองสกลนคร", "สกลนคร"],
    ["งิ้วด่อน", "เมืองสกลนคร", "สกลนคร"],
    ["หนองบัวสิม", "เมืองสกลนคร", "สกลนคร"],
  ],

  // =================== นครพนม ===================
  "48000": [
    ["ในเมือง", "เมืองนครพนม", "นครพนม"],
    ["หนองญาติ", "เมืองนครพนม", "นครพนม"],
    ["อาจสามารถ", "เมืองนครพนม", "นครพนม"],
    ["ขามเฒ่า", "เมืองนครพนม", "นครพนม"],
  ],

  // =================== มุกดาหาร ===================
  "49000": [
    ["มุกดาหาร", "เมืองมุกดาหาร", "มุกดาหาร"],
    ["ศรีบุญเรือง", "เมืองมุกดาหาร", "มุกดาหาร"],
    ["บ้านโคก", "เมืองมุกดาหาร", "มุกดาหาร"],
  ],

  // =================== เชียงใหม่ ===================
  "50000": [
    ["ช้างคลาน", "เมืองเชียงใหม่", "เชียงใหม่"],
    ["พระสิงห์", "เมืองเชียงใหม่", "เชียงใหม่"],
    ["หายยา", "เมืองเชียงใหม่", "เชียงใหม่"],
    ["ศรีภูมิ", "เมืองเชียงใหม่", "เชียงใหม่"],
    ["สุเทพ", "เมืองเชียงใหม่", "เชียงใหม่"],
    ["แม่เหียะ", "เมืองเชียงใหม่", "เชียงใหม่"],
    ["ป่าแดด", "เมืองเชียงใหม่", "เชียงใหม่"],
    ["หนองหอย", "เมืองเชียงใหม่", "เชียงใหม่"],
    ["ท่าศาลา", "เมืองเชียงใหม่", "เชียงใหม่"],
    ["หนองป่าครั่ง", "เมืองเชียงใหม่", "เชียงใหม่"],
    ["ฟ้าฮ่าม", "เมืองเชียงใหม่", "เชียงใหม่"],
    ["ป่าตัน", "เมืองเชียงใหม่", "เชียงใหม่"],
  ],
  "50200": [
    ["สันทราย", "สันทราย", "เชียงใหม่"],
    ["สันพระเนตร", "สันทราย", "เชียงใหม่"],
    ["สันนาเม็ง", "สันทราย", "เชียงใหม่"],
    ["สันป่าเปา", "สันทราย", "เชียงใหม่"],
  ],
  "50290": [
    ["ดอยสะเก็ด", "ดอยสะเก็ด", "เชียงใหม่"],
    ["เชิงดอย", "ดอยสะเก็ด", "เชียงใหม่"],
  ],

  // =================== ลำพูน ===================
  "51000": [
    ["ในเมือง", "เมืองลำพูน", "ลำพูน"],
    ["เหมืองง่า", "เมืองลำพูน", "ลำพูน"],
    ["อุโมงค์", "เมืองลำพูน", "ลำพูน"],
    ["หนองช้างคืน", "เมืองลำพูน", "ลำพูน"],
  ],

  // =================== ลำปาง ===================
  "52000": [
    ["เวียงเหนือ", "เมืองลำปาง", "ลำปาง"],
    ["สวนดอก", "เมืองลำปาง", "ลำปาง"],
    ["หัวเวียง", "เมืองลำปาง", "ลำปาง"],
    ["พระบาท", "เมืองลำปาง", "ลำปาง"],
    ["ชมพู", "เมืองลำปาง", "ลำปาง"],
    ["กล้วยแพะ", "เมืองลำปาง", "ลำปาง"],
  ],

  // =================== อุตรดิตถ์ ===================
  "53000": [
    ["ท่าอิฐ", "เมืองอุตรดิตถ์", "อุตรดิตถ์"],
    ["ท่าเสา", "เมืองอุตรดิตถ์", "อุตรดิตถ์"],
    ["บ้านเกาะ", "เมืองอุตรดิตถ์", "อุตรดิตถ์"],
    ["ป่าเซ่า", "เมืองอุตรดิตถ์", "อุตรดิตถ์"],
  ],

  // =================== แพร่ ===================
  "54000": [
    ["ในเวียง", "เมืองแพร่", "แพร่"],
    ["นาจักร", "เมืองแพร่", "แพร่"],
    ["น้ำชำ", "เมืองแพร่", "แพร่"],
    ["ป่าแมต", "เมืองแพร่", "แพร่"],
    ["บ้านถิ่น", "เมืองแพร่", "แพร่"],
  ],

  // =================== น่าน ===================
  "55000": [
    ["ในเวียง", "เมืองน่าน", "น่าน"],
    ["บ่อสวก", "เมืองน่าน", "น่าน"],
    ["ผาสิงห์", "เมืองน่าน", "น่าน"],
    ["ไชยสถาน", "เมืองน่าน", "น่าน"],
  ],

  // =================== พะเยา ===================
  "56000": [
    ["เวียง", "เมืองพะเยา", "พะเยา"],
    ["แม่ต๋ำ", "เมืองพะเยา", "พะเยา"],
    ["แม่นาเรือ", "เมืองพะเยา", "พะเยา"],
    ["ท่าวังทอง", "เมืองพะเยา", "พะเยา"],
  ],

  // =================== เชียงราย ===================
  "57000": [
    ["เวียง", "เมืองเชียงราย", "เชียงราย"],
    ["รอบเวียง", "เมืองเชียงราย", "เชียงราย"],
    ["บ้านดู่", "เมืองเชียงราย", "เชียงราย"],
    ["นางแล", "เมืองเชียงราย", "เชียงราย"],
    ["แม่ข้าวต้ม", "เมืองเชียงราย", "เชียงราย"],
    ["แม่ยาว", "เมืองเชียงราย", "เชียงราย"],
    ["สันทราย", "เมืองเชียงราย", "เชียงราย"],
    ["ท่าสาย", "เมืองเชียงราย", "เชียงราย"],
  ],

  // =================== แม่ฮ่องสอน ===================
  "58000": [
    ["จองคำ", "เมืองแม่ฮ่องสอน", "แม่ฮ่องสอน"],
    ["ผาบ่อง", "เมืองแม่ฮ่องสอน", "แม่ฮ่องสอน"],
    ["ปางหมู", "เมืองแม่ฮ่องสอน", "แม่ฮ่องสอน"],
  ],

  // =================== นครสวรรค์ ===================
  "60000": [
    ["ปากน้ำโพ", "เมืองนครสวรรค์", "นครสวรรค์"],
    ["กลางแดด", "เมืองนครสวรรค์", "นครสวรรค์"],
    ["เกรียงไกร", "เมืองนครสวรรค์", "นครสวรรค์"],
    ["บ้านมะเกลือ", "เมืองนครสวรรค์", "นครสวรรค์"],
  ],

  // =================== อุทัยธานี ===================
  "61000": [
    ["อุทัยใหม่", "เมืองอุทัยธานี", "อุทัยธานี"],
    ["น้ำซึม", "เมืองอุทัยธานี", "อุทัยธานี"],
    ["สะแกกรัง", "เมืองอุทัยธานี", "อุทัยธานี"],
    ["ดอนขวาง", "เมืองอุทัยธานี", "อุทัยธานี"],
  ],

  // =================== กำแพงเพชร ===================
  "62000": [
    ["ในเมือง", "เมืองกำแพงเพชร", "กำแพงเพชร"],
    ["ไตรตรึงษ์", "เมืองกำแพงเพชร", "กำแพงเพชร"],
    ["อ่างทอง", "เมืองกำแพงเพชร", "กำแพงเพชร"],
    ["นาบ่อคำ", "เมืองกำแพงเพชร", "กำแพงเพชร"],
  ],

  // =================== ตาก ===================
  "63000": [
    ["ระแหง", "เมืองตาก", "ตาก"],
    ["หนองหลวง", "เมืองตาก", "ตาก"],
    ["เชียงเงิน", "เมืองตาก", "ตาก"],
    ["หัวเดียด", "เมืองตาก", "ตาก"],
  ],

  // =================== สุโขทัย ===================
  "64000": [
    ["ธานี", "เมืองสุโขทัย", "สุโขทัย"],
    ["บ้านสวน", "เมืองสุโขทัย", "สุโขทัย"],
    ["เมืองเก่า", "เมืองสุโขทัย", "สุโขทัย"],
    ["ปากแคว", "เมืองสุโขทัย", "สุโขทัย"],
    ["ยางซ้าย", "เมืองสุโขทัย", "สุโขทัย"],
  ],

  // =================== พิษณุโลก ===================
  "65000": [
    ["ในเมือง", "เมืองพิษณุโลก", "พิษณุโลก"],
    ["วังน้ำคู้", "เมืองพิษณุโลก", "พิษณุโลก"],
    ["อรัญญิก", "เมืองพิษณุโลก", "พิษณุโลก"],
    ["บึงพระ", "เมืองพิษณุโลก", "พิษณุโลก"],
    ["ไผ่ขอดอน", "เมืองพิษณุโลก", "พิษณุโลก"],
  ],

  // =================== พิจิตร ===================
  "66000": [
    ["ในเมือง", "เมืองพิจิตร", "พิจิตร"],
    ["ท่าฬ่อ", "เมืองพิจิตร", "พิจิตร"],
    ["คลองคะเชนทร์", "เมืองพิจิตร", "พิจิตร"],
    ["ปากทาง", "เมืองพิจิตร", "พิจิตร"],
  ],

  // =================== เพชรบูรณ์ ===================
  "67000": [
    ["ในเมือง", "เมืองเพชรบูรณ์", "เพชรบูรณ์"],
    ["ตะเบาะ", "เมืองเพชรบูรณ์", "เพชรบูรณ์"],
    ["บ้านโตก", "เมืองเพชรบูรณ์", "เพชรบูรณ์"],
    ["สะเดียง", "เมืองเพชรบูรณ์", "เพชรบูรณ์"],
    ["ชอนไพร", "เมืองเพชรบูรณ์", "เพชรบูรณ์"],
  ],

  // =================== ราชบุรี ===================
  "70000": [
    ["หน้าเมือง", "เมืองราชบุรี", "ราชบุรี"],
    ["เขาแร้ง", "เมืองราชบุรี", "ราชบุรี"],
    ["เจดีย์หัก", "เมืองราชบุรี", "ราชบุรี"],
    ["ดอนตะโก", "เมืองราชบุรี", "ราชบุรี"],
    ["หลุมดิน", "เมืองราชบุรี", "ราชบุรี"],
  ],

  // =================== กาญจนบุรี ===================
  "71000": [
    ["บ้านเหนือ", "เมืองกาญจนบุรี", "กาญจนบุรี"],
    ["บ้านใต้", "เมืองกาญจนบุรี", "กาญจนบุรี"],
    ["ปากแพรก", "เมืองกาญจนบุรี", "กาญจนบุรี"],
    ["ท่ามะขาม", "เมืองกาญจนบุรี", "กาญจนบุรี"],
    ["แก่งเสี้ยน", "เมืองกาญจนบุรี", "กาญจนบุรี"],
  ],

  // =================== สุพรรณบุรี ===================
  "72000": [
    ["ท่าพี่เลี้ยง", "เมืองสุพรรณบุรี", "สุพรรณบุรี"],
    ["รั้วใหญ่", "เมืองสุพรรณบุรี", "สุพรรณบุรี"],
    ["ทับตีเหล็ก", "เมืองสุพรรณบุรี", "สุพรรณบุรี"],
    ["ท่าระหัด", "เมืองสุพรรณบุรี", "สุพรรณบุรี"],
  ],

  // =================== นครปฐม ===================
  "73000": [
    ["พระปฐมเจดีย์", "เมืองนครปฐม", "นครปฐม"],
    ["บางแขม", "เมืองนครปฐม", "นครปฐม"],
    ["พระประโทน", "เมืองนครปฐม", "นครปฐม"],
    ["ธรรมศาลา", "เมืองนครปฐม", "นครปฐม"],
  ],

  // =================== สมุทรสาคร ===================
  "74000": [
    ["มหาชัย", "เมืองสมุทรสาคร", "สมุทรสาคร"],
    ["ท่าฉลอม", "เมืองสมุทรสาคร", "สมุทรสาคร"],
    ["โกรกกราก", "เมืองสมุทรสาคร", "สมุทรสาคร"],
  ],

  // =================== สมุทรสงคราม ===================
  "75000": [
    ["แม่กลอง", "เมืองสมุทรสงคราม", "สมุทรสงคราม"],
    ["บางขันแตก", "เมืองสมุทรสงคราม", "สมุทรสงคราม"],
    ["ลาดใหญ่", "เมืองสมุทรสงคราม", "สมุทรสงคราม"],
    ["บ้านปรก", "เมืองสมุทรสงคราม", "สมุทรสงคราม"],
  ],

  // =================== เพชรบุรี ===================
  "76000": [
    ["คลองกระแชง", "เมืองเพชรบุรี", "เพชรบุรี"],
    ["ท่าราบ", "เมืองเพชรบุรี", "เพชรบุรี"],
    ["คลองกระแชง", "เมืองเพชรบุรี", "เพชรบุรี"],
    ["บางจาน", "เมืองเพชรบุรี", "เพชรบุรี"],
    ["โพพระ", "เมืองเพชรบุรี", "เพชรบุรี"],
  ],

  // =================== ประจวบคีรีขันธ์ ===================
  "77000": [
    ["ประจวบคีรีขันธ์", "เมืองประจวบคีรีขันธ์", "ประจวบคีรีขันธ์"],
    ["เกาะหลัก", "เมืองประจวบคีรีขันธ์", "ประจวบคีรีขันธ์"],
    ["คลองวาฬ", "เมืองประจวบคีรีขันธ์", "ประจวบคีรีขันธ์"],
    ["ห้วยทราย", "เมืองประจวบคีรีขันธ์", "ประจวบคีรีขันธ์"],
  ],
  "77120": [
    ["หัวหิน", "หัวหิน", "ประจวบคีรีขันธ์"],
    ["หนองแก", "หัวหิน", "ประจวบคีรีขันธ์"],
    ["หินเหล็กไฟ", "หัวหิน", "ประจวบคีรีขันธ์"],
    ["บึงนคร", "หัวหิน", "ประจวบคีรีขันธ์"],
    ["ทับใต้", "หัวหิน", "ประจวบคีรีขันธ์"],
    ["โป่งแดง", "หัวหิน", "ประจวบคีรีขันธ์"],
  ],

  // =================== นครศรีธรรมราช ===================
  "80000": [
    ["ในเมือง", "เมืองนครศรีธรรมราช", "นครศรีธรรมราช"],
    ["ท่าวัง", "เมืองนครศรีธรรมราช", "นครศรีธรรมราช"],
    ["คลัง", "เมืองนครศรีธรรมราช", "นครศรีธรรมราช"],
    ["ท่าตะเภา", "เมืองนครศรีธรรมราช", "นครศรีธรรมราช"],
    ["ปากนคร", "เมืองนครศรีธรรมราช", "นครศรีธรรมราช"],
    ["โพธิ์เสด็จ", "เมืองนครศรีธรรมราช", "นครศรีธรรมราช"],
  ],

  // =================== กระบี่ ===================
  "81000": [
    ["กระบี่ใหญ่", "เมืองกระบี่", "กระบี่"],
    ["กระบี่น้อย", "เมืองกระบี่", "กระบี่"],
    ["ปากน้ำ", "เมืองกระบี่", "กระบี่"],
    ["เขาคราม", "เมืองกระบี่", "กระบี่"],
    ["เขาทอง", "เมืองกระบี่", "กระบี่"],
    ["ทับปริก", "เมืองกระบี่", "กระบี่"],
  ],

  // =================== พังงา ===================
  "82000": [
    ["ท้ายช้าง", "เมืองพังงา", "พังงา"],
    ["นบปริง", "เมืองพังงา", "พังงา"],
    ["ถ้ำน้ำผุด", "เมืองพังงา", "พังงา"],
    ["บางเตย", "เมืองพังงา", "พังงา"],
    ["ตากแดด", "เมืองพังงา", "พังงา"],
  ],

  // =================== ภูเก็ต ===================
  "83000": [
    ["ตลาดใหญ่", "เมืองภูเก็ต", "ภูเก็ต"],
    ["ตลาดเหนือ", "เมืองภูเก็ต", "ภูเก็ต"],
    ["รัษฎา", "เมืองภูเก็ต", "ภูเก็ต"],
    ["เกาะแก้ว", "เมืองภูเก็ต", "ภูเก็ต"],
    ["ฉลอง", "เมืองภูเก็ต", "ภูเก็ต"],
    ["ราไวย์", "เมืองภูเก็ต", "ภูเก็ต"],
    ["กะรน", "เมืองภูเก็ต", "ภูเก็ต"],
  ],
  "83110": [
    ["สาคู", "ถลาง", "ภูเก็ต"],
    ["เทพกษัตริย์", "ถลาง", "ภูเก็ต"],
    ["ศรีสุนทร", "ถลาง", "ภูเก็ต"],
    ["ป่าคลอก", "ถลาง", "ภูเก็ต"],
    ["ไม้ขาว", "ถลาง", "ภูเก็ต"],
    ["เชิงทะเล", "ถลาง", "ภูเก็ต"],
  ],
  "83120": [
    ["กะทู้", "กะทู้", "ภูเก็ต"],
    ["ป่าตอง", "กะทู้", "ภูเก็ต"],
    ["กมลา", "กะทู้", "ภูเก็ต"],
  ],
  "83130": [
    ["วิชิต", "เมืองภูเก็ต", "ภูเก็ต"],
  ],

  // =================== สุราษฎร์ธานี ===================
  "84000": [
    ["ตลาด", "เมืองสุราษฎร์ธานี", "สุราษฎร์ธานี"],
    ["มะขามเตี้ย", "เมืองสุราษฎร์ธานี", "สุราษฎร์ธานี"],
    ["บางใบไม้", "เมืองสุราษฎร์ธานี", "สุราษฎร์ธานี"],
    ["คลองน้อย", "เมืองสุราษฎร์ธานี", "สุราษฎร์ธานี"],
  ],

  // =================== ระนอง ===================
  "85000": [
    ["เขานิเวศน์", "เมืองระนอง", "ระนอง"],
    ["ราชกรูด", "เมืองระนอง", "ระนอง"],
    ["หงาว", "เมืองระนอง", "ระนอง"],
    ["บางริ้น", "เมืองระนอง", "ระนอง"],
  ],

  // =================== ชุมพร ===================
  "86000": [
    ["ท่าตะเภา", "เมืองชุมพร", "ชุมพร"],
    ["ปากน้ำ", "เมืองชุมพร", "ชุมพร"],
    ["บ้านนา", "เมืองชุมพร", "ชุมพร"],
    ["วังไผ่", "เมืองชุมพร", "ชุมพร"],
    ["วังใหม่", "เมืองชุมพร", "ชุมพร"],
  ],

  // =================== สงขลา ===================
  "90000": [
    ["บ่อยาง", "เมืองสงขลา", "สงขลา"],
    ["เขารูปช้าง", "เมืองสงขลา", "สงขลา"],
    ["เกาะแต้ว", "เมืองสงขลา", "สงขลา"],
    ["พะวง", "เมืองสงขลา", "สงขลา"],
    ["ทุ่งหวัง", "เมืองสงขลา", "สงขลา"],
    ["เขาแดง", "เมืองสงขลา", "สงขลา"],
  ],
  "90110": [
    ["หาดใหญ่", "หาดใหญ่", "สงขลา"],
    ["หาดใหญ่", "หาดใหญ่", "สงขลา"],
    ["คลองอู่ตะเภา", "หาดใหญ่", "สงขลา"],
    ["คลองแห", "หาดใหญ่", "สงขลา"],
    ["คอหงส์", "หาดใหญ่", "สงขลา"],
    ["คูเต่า", "หาดใหญ่", "สงขลา"],
    ["น้ำน้อย", "หาดใหญ่", "สงขลา"],
    ["บ้านพรุ", "หาดใหญ่", "สงขลา"],
    ["พะตง", "หาดใหญ่", "สงขลา"],
  ],

  // =================== สตูล ===================
  "91000": [
    ["พิมาน", "เมืองสตูล", "สตูล"],
    ["คลองขุด", "เมืองสตูล", "สตูล"],
    ["ควนขัน", "เมืองสตูล", "สตูล"],
    ["บ้านควน", "เมืองสตูล", "สตูล"],
  ],

  // =================== ตรัง ===================
  "92000": [
    ["ทับเที่ยง", "เมืองตรัง", "ตรัง"],
    ["บ้านโพธิ์", "เมืองตรัง", "ตรัง"],
    ["นาพละ", "เมืองตรัง", "ตรัง"],
    ["บางรัก", "เมืองตรัง", "ตรัง"],
    ["นาบินหลา", "เมืองตรัง", "ตรัง"],
    ["บ้านควน", "เมืองตรัง", "ตรัง"],
  ],

  // =================== พัทลุง ===================
  "93000": [
    ["คูหาสวรรค์", "เมืองพัทลุง", "พัทลุง"],
    ["เขาเจียก", "เมืองพัทลุง", "พัทลุง"],
    ["ท่ามิหรำ", "เมืองพัทลุง", "พัทลุง"],
    ["ลำปำ", "เมืองพัทลุง", "พัทลุง"],
  ],

  // =================== ปัตตานี ===================
  "94000": [
    ["สะบารัง", "เมืองปัตตานี", "ปัตตานี"],
    ["อาเนาะรู", "เมืองปัตตานี", "ปัตตานี"],
    ["จะบังติกอ", "เมืองปัตตานี", "ปัตตานี"],
    ["บานา", "เมืองปัตตานี", "ปัตตานี"],
    ["ตันหยงลุโละ", "เมืองปัตตานี", "ปัตตานี"],
    ["คลองมานิง", "เมืองปัตตานี", "ปัตตานี"],
  ],

  // =================== ยะลา ===================
  "95000": [
    ["สะเตง", "เมืองยะลา", "ยะลา"],
    ["บุดี", "เมืองยะลา", "ยะลา"],
    ["ยุโป", "เมืองยะลา", "ยะลา"],
    ["ลิดล", "เมืองยะลา", "ยะลา"],
    ["ยะลา", "เมืองยะลา", "ยะลา"],
  ],

  // =================== นราธิวาส ===================
  "96000": [
    ["บางนาค", "เมืองนราธิวาส", "นราธิวาส"],
    ["ลำภู", "เมืองนราธิวาส", "นราธิวาส"],
    ["กะลุวอ", "เมืองนราธิวาส", "นราธิวาส"],
    ["กะลุวอเหนือ", "เมืองนราธิวาส", "นราธิวาส"],
  ],
};

export function getAddressOptions(postalCode: string): ThaiAddressOption[] {
  const entries = RAW[postalCode];
  if (!entries) return [];
  return entries.map(([subDistrict, district, province]) => ({ subDistrict, district, province }));
}

export function getUniqueProvinces(postalCode: string): string[] {
  return Array.from(new Set(getAddressOptions(postalCode).map(o => o.province)));
}

export function getDistricts(postalCode: string, province: string): string[] {
  return Array.from(new Set(
    getAddressOptions(postalCode)
      .filter(o => o.province === province)
      .map(o => o.district)
  ));
}

export function getSubDistricts(postalCode: string, province: string, district: string): string[] {
  return getAddressOptions(postalCode)
    .filter(o => o.province === province && o.district === district)
    .map(o => o.subDistrict);
}
